import React, { FC } from 'react';
import { fromMarkdown } from '@lib/utils';
import { InfoAndCTAT } from '@factories/RowFactory/components/InfoAndCTA/types';
import {
  StyledInfoAndCTA,
  StyledInfoAndCTASection,
} from '@factories/RowFactory/components/InfoAndCTA/styled/StyledInfoAndCTA';
import { Cta } from '@components/Molecules';

export const InfoAndCTA: FC<InfoAndCTAT> = ({ display, title, description, CTA }) => {
  if (!display) return null;

  return (
    <StyledInfoAndCTASection>
      <StyledInfoAndCTA>
        <div>
          <h4>{title}</h4>
          {description && fromMarkdown({ text: description, isHeading: false })}
        </div>

        <Cta {...CTA} />
      </StyledInfoAndCTA>
    </StyledInfoAndCTASection>
  );
};

export default InfoAndCTA;
